import React from 'react';
import CommonLayout from "../../layouts/master/index";
import List from "./List";

const Customers = () => {
  return (
    <>
    <CommonLayout>
      <>
      <List/>
      </>
    </CommonLayout>
    </>
  )
}

export default Customers